import { render, staticRenderFns } from "./storeEdit.vue?vue&type=template&id=22130992&"
import script from "./storeEdit.vue?vue&type=script&lang=js&"
export * from "./storeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports